import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "parking-data" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "parking-data__table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "parking-data__description",
      innerHTML: _ctx.descriptionTop
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.hasSpots)
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", null, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Kategoria miejsc"),
              _createElementVNode("th", null, "Wszystkie miejsca"),
              _createElementVNode("th", null, "Zajęte miejsca")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.category ? _ctx.category : this.noData), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.parkingSpots ? _ctx.parkingSpots : this.noData), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.lastStatus ? _ctx.lastStatus.occupiedSpots : this.noData), 1)
            ])
          ])
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "empty-data" }, " Brak informacji o aktualnej zajętości. ", -1))
    ], 2)
  ]))
}